(
    function (skyward, $, undefined)
    {
        skyward.gradebookcodeeel = skyward.gradebookcodeeel || {};

        const requestHandler = skyward.extensions.getSingleRequestHandler();

        const idGenerator = skyward.extensions.getIdGenerator("popup", "_gradebookCodeEelBrowse");

        var init = function (selector)
        {
            $(selector).find(".gradebookCodeEEL:not(.eventsBound)").each(function ()
            {
                skyward.gradebookcodeeel.registerCodeEEL($(this));
            });

            $(selector).find(".gradebookCodeEEL").off("change").on("change", function () { skyward.gradebookcodeeel.handleChange($(this)); });
        };

        skyward.gradebookcodeeel.handleChange = function (gradebookCodeEEL, selectedValueID)
        {
            var area = "Gradebook";
            var controller = "Gradebook";
            var action = "ValidateGradebookCodeEEL";

            var input = gradebookCodeEEL.find(".gradebookInputCodeEEL");

            var setBackingPercent = function (input, returnData)
            {
                if (returnData.backingPercent != null)
                {
                    input.data("backingPercent", returnData.backingPercent);
                }
            };

            var data = skyward.gradebookcodeeel.handleChangeNoSave(gradebookCodeEEL, selectedValueID);

            return $.ajax(
            {
                url: skyward.global.virtualDir + area + "/" + controller + "/" + action,
                type: "POST",
                dataType: "JSON",
                data: data,
                activityIndicator: { silent: data.silentAjax },
                success: function (returnData)
                {
                    if (returnData.hasMatch)
                    {
                        setBackingPercent(input, returnData);
                        input.trigger("gradebookInputCodeEELValid", [returnData]);
                    }
                    else
                    {
                        input.trigger("gradebookInputCodeEELInvalid", [returnData]);
                    }

                    var modalLayers = skyward.modalLayer.getOpenModalLayers();
                    if (modalLayers && modalLayers.length > 0)
                    {
                        for (var i = 0; i < modalLayers.length; i++)
                        {
                            var modalLayer = $(modalLayers[i]);

                            if (modalLayer.find('div.gradebookCodeEELPopup').length > 0)
                            {
                                skyward.modalLayer.closeModalLayer(modalLayer);
                            }
                        }
                    }
                }
            });
        };

        skyward.gradebookcodeeel.handleChangeNoSave = function (gradebookCodeEEL, selectedValueID)
        {
            var input = gradebookCodeEEL.find(".gradebookInputCodeEEL");

            var data = input.data();

            var wrapperData = gradebookCodeEEL.data();
            delete wrapperData.selectedValueID;
            data.postData = JSON.stringify(wrapperData);
            data.selectedValueID = selectedValueID;

            data.value = skyward.controls.getValue(input);
            return data;
        };

        skyward.gradebookcodeeel.setValue = function (input, displayValue, selectedValueID, suppressChangeEvents)
        {
            if ((displayValue == null || displayValue == "") && !input.hasClass('scoreClarifier'))
            {
                displayValue = "*";
            }

            input.data("displayValue", displayValue);
            input.data("selectedValueID", selectedValueID);
            input.data("mostRecentEditableDisplayValue", displayValue);

            skyward.controls.setValue(input, displayValue, suppressChangeEvents);
        };

        skyward.gradebookcodeeel.getData = function (input)
        {
            var inputData = input.data();

            if (inputData.selectedValueID == null)
            {
                inputData.selectedValueID = null;
            }

            var returnData =
            {
                displayValue: inputData.displayValue,
                selectedValueID: inputData.selectedValueID,
                mostRecentEditableDisplayValue: inputData.mostRecentEditableDisplayValue,
                backingPercent: inputData.backingPercent
            };

            return returnData;
        };

        skyward.gradebookcodeeel.setOriginalValueData = function (input, displayValue, selectedValueID)
        {
            input.data("originalValue", displayValue);
            input.data("originalDisplayValue", displayValue);
            input.data("originalSelectedValueID", selectedValueID);
        };

        skyward.gradebookcodeeel.getOriginalValueData = function (input)
        {
            var inputData = input.data();

            if (inputData.originalSelectedValueID == null)
            {
                inputData.originalSelectedValueID = "";
            }

            var returnData =
            {
                originalDisplayValue: inputData.originalDisplayValue,
                originalSelectedValueID: inputData.originalSelectedValueID
            };
            return returnData;
        };

        skyward.gradebookcodeeel.registerCodeEEL = function (codeEEL)
        {
            let lastValue; // stores the last searched value to prevent unnecessary searches
            let selectedValue = null;
            const eelData =
            {
                codeEEL: codeEEL,
                eelTextBox: codeEEL.find(".gradebookInputCodeEEL"),
                dropDownArrow: codeEEL.find(".gradebookCodeEELButton"),
                layer: null
            };
            eelData.eelTextBoxData = eelData.eelTextBox.data();
            if (codeEEL.length > 0)
            {
                var wrapperData = codeEEL.data();
                eelData.eelTextBoxData.postData = JSON.stringify(wrapperData);
            }

            var getBrowsePostData = function (textBox)
            {
                var postData = {};

                postData.filter = JSON.stringify(eelData.filter);
                postData.isGradebookCodeEEL = "true";
                $.extend(postData, eelData.eelTextBoxData);

                if (!textBox.data("dynamicfiltervalue"))
                {
                    return $.extend({}, eelData.postData, postData);
                }

                var filterPostData = {};
                var dependentFields = textBox.data("dynamicfilterfield").split(',');
                var dependentValues = textBox.data("dynamicfiltervalue").split(',');
                var dependentAttributes = textBox.data("dynamicfilterattribute").split(',');

                for (var i = 0; i < dependentFields.length; i++)
                {
                    var dependentElement = $('[name="' + dependentValues[i] + '"]');
                    if (dependentElement.length === 0)
                    {
                        dependentElement = $('#' + dependentValues[i] + ' .dmsBackingData');
                    }

                    var dependentStringArray = dependentAttributes[i].split("-");
                    if (dependentStringArray.length >= 3 && dependentStringArray[2].length > 0)
                    {
                        var finalDependentString = dependentStringArray[1] + dependentStringArray[2].charAt(0).toUpperCase() + dependentStringArray[2].slice(1);

                        if (typeof dependentElement.data(finalDependentString) !== 'undefined')
                        {
                            postData[dependentFields[i]] = dependentElement.data(finalDependentString);
                        }
                    }
                    else
                    {
                        postData[dependentFields[i]] = skyward.controls.getValue(dependentElement);
                    }
                }

                var dependentBrowsePostData = {};
                for (var key in eelData.postData)
                {
                    var fieldName = key.substring(key.lastIndexOf('.') + 1);

                    if (filterPostData[fieldName] && filterPostData[fieldName] != eelData.postData[key])
                    {
                        dependentBrowsePostData[key] = filterPostData[fieldName];
                    }
                    else
                    {
                        dependentBrowsePostData[key] = eelData.postData[key];
                    }
                }

                return $.extend({}, dependentBrowsePostData, filterPostData, postData);
            };

            const closeOpenEelBrowse = function (browseId, textbox)
            {
                eelData.layer = null;
                lastValue = null;
                requestHandler.closeOpenRequest();
                textbox.focus();
                delete skyward.browse.browseList[browseId];
                skyward.browse.openBrowses.splice(skyward.browse.openBrowses.indexOf(browseId), 1);
            };

            const handleTabPress = function (_browseId, _textbox)
            {
                skyward.browse.handlePopupBrowseTabPress();
            };

            const createModalLayer = function (browseId, textbox)
            {
                var textBoxId = codeEEL.attr("id");
                var popupContent = $("<div>", { "class": "popup gradebookCodeEELPopup", id: textBoxId + "_popup" });
                popupContent.append($("<div>", { id: browseId, "class": "browse" }));

                skyward.browse.eventCallbacks.recordSelectionMade.registerCallback(selectionMadeHandler);

                var beforeClose = function (layer, reason)
                {
                    if (reason == "glassClick" || reason == "escape")
                    {
                        return;
                    }

                    var selectedValueID = selectedValue;
                    if (selectedValueID == null)
                    {
                        selectedValueID = "";
                    }

                    var input = codeEEL.find(".gradebookInputCodeEEL");

                    if (selectedValueID != skyward.gradebookcodeeel.getData(input).selectedValueID)
                    {
                        skyward.gradebookcodeeel.handleChange.apply(codeEEL, [codeEEL, selectedValueID]);
                    }

                    skyward.browse.eventCallbacks.recordSelectionMade.deregisterCallback(selectionMadeHandler);

                    closeOpenEelBrowse(browseId, textbox);
                };

                var bindings =
                [
                    {
                        onEvents: "keydown",
                        bindTo: codeEEL,
                        runFunction: function (event)
                        {
                            if (event.keyCode && event.keyCode == 9)
                            {
                                handleTabPress(browseId, $(this));
                                event.preventDefault();
                            }
                        }
                    },
                    {
                        onEvents: "input",
                        bindTo: codeEEL,
                        runFunction: skyward.debounce(filterInputEvents(inputEvent))
                    }
                ];

                skyward.modalLayer.showCodeEELDialog(popupContent, textbox, codeEEL, beforeClose, eelData, bindings);

                function selectionMadeHandler(eventData)
                {
                    if (eventData.browseId === browseId)
                    {
                        selectedValue = eventData.selectedId;
                    }
                }
            };

            var addToBrowseList = function (browseId, textbox)
            {
                var data = textbox.data();
                skyward.browse.browseList[browseId] =
                {
                    id: browseId,
                    pageModule: data.pageModule,
                    pageObject: data.pageObject,
                    pageScreen: "codeBrowse",
                    browseType: "Default",

                    routeModule: data.pageModule,
                    routeObject: data.pageObject,
                    browseName: "browse",

                    dataModule: data.pageModule, //TODO: PR 4339258 update to use actual dataModule instead of pageModule
                    dataObject: data.pageObject, //TODO: PR 4339258 update to use actual dataObject instead of pageObject

                    selectMode: true,
                    refreshTimeout: -1,
                    data: getBrowsePostData(textbox),
                    keyEventsEnabled: true,
                    renderViewButton: true,
                    renderFilterButton: false,
                    renderQuickFilter: false,
                    disableBrowseSort: true,
                    hideOptionsButton: true,
                    preventColumnResize: true,
                    hideMoreMenuArea: true,
                    queryParameterData: eelData.codeEELQueryParameterData,
                    routeHash: eelData.eelTextBoxData.routeHash
                };

                skyward.browse.openBrowses.push(browseId);
            };

            var inputEvent = function ()
            {
                var textbox = $(this);

                if (lastValue != null && textbox.val().toLowerCase() === lastValue.toLowerCase())
                {
                    return;
                }

                if (eelData.layer == null || eelData.layer.onscreen == false)
                {
                    showPopup(textbox);
                }

                doSearch(textbox.val());
                lastValue = textbox.val();
                selectedValue = null;
            };

            var previousValues = {};

            // filter input events for IE 10 & 11
            var filterInputEvents = function (inputHandler, one)
            {
                var filteredFunction = function (event)
                {
                    var input = $(this).find('.gradebookInputCodeEEL');
                    input = input && input.length > 0 ? input[0] : this;
                    if (event.type !== "input")
                    {
                        inputHandler.apply(input, arguments);
                    }

                    if (!previousValues.hasOwnProperty(input))
                    {
                        previousValues[input] = input.defaultValue;
                    }

                    var newValue = $(input).val();

                    if (newValue != previousValues[input])
                    {
                        inputHandler.apply(input, arguments);
                        previousValues[input] = newValue;
                    }
                    else if (one)
                    {
                        // re-attach event
                        addInitialInputEvent();
                    }
                };

                // Use the same guid, so the event can removed with .off()
                filteredFunction.guid = inputHandler.guid || (inputHandler.guid = jQuery.guid++);

                return filteredFunction;
            };

            var showPopup = function (input)
            {
                const browseId = idGenerator.getNewId();
                addToBrowseList(browseId, input);
                createModalLayer(browseId, input);
            };

            var doSearch = function (searchText)
            {
                const browse = skyward.browse.getInnerBrowse(eelData.layer.container);
                if (browse === undefined)
                {
                    return;
                }
                const browseId = browse.id;
                if (!searchText)
                {
                    eelData.eelTextBoxData.seekId = eelData.eelTextBox.data().selectedValueID;
                }
                else
                {
                    eelData.eelTextBoxData.seekId = null;
                }

                requestHandler.request = skyward.browse.performGradebookCodeEELSearch(browseId, eelData.eelTextBoxData, searchText);
                $.when(requestHandler.request).done(function (data)
                {
                    handleGradebookCodeEELFailure(data);
                });
            };

            eelData.dropDownArrow.off('click').on("click", function (event)
            {
                const arrow = $(this);
                if (arrow.hasClass("ui-disabled"))
                {
                    return;
                }

                // Set the selected id to the hidden value on load in case an id is already selected
                selectedValue = eelData.eelTextBox.data().selectedValueID;
                var input = arrow.siblings(".gradebookInputCodeEEL");
                if (eelData.layer == null || eelData.layer.onscreen == false)
                {
                    showPopup(input);
                    doSearch();
                }
                else
                {
                    eelData.layer.close('glassClick');
                }
                event.preventDefault();
                event.stopPropagation();
            });

            codeEEL.addClass("eventsBound");
        };

        var handleGradebookCodeEELFailure = function (data)
        {
            if (data && data.success == false && data.popupHTML && data.popupHTML.Content)
            {
                skyward.modalLayer.showReloadDialog("Gradebook Alert", data.popupHTML.Content);
            }
        }

        var events =
        {

        };

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);
        skyward.events.registerEvents('gradebookcodeeel', events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);